import { WebHttpClientWithErrorToastInstance } from '~src/httpClient/WebHttpClientWithErrorToast';

import { DeleteSiteSMTPCredentialRequest } from './requests/DeleteSiteSMTPCredentialTagRequest';
import { ISiteSMTPSettings, SetSiteSMTPCredentialRequest } from './requests/SetSiteSMTPCredentialTagRequest';

export namespace ExternalSMTPConfiguration {
  export async function setSiteSMTPCredential(emailCustomizationSettings: ISiteSMTPSettings, siteLuid: string) {
    return await WebHttpClientWithErrorToastInstance.sendTagRequest(new SetSiteSMTPCredentialRequest({...emailCustomizationSettings, site_luid: siteLuid}));
  }

  export async function deleteSiteSMTPCredential(siteLuid: string) {
    return await WebHttpClientWithErrorToastInstance.sendTagRequest(new DeleteSiteSMTPCredentialRequest({site_luid: siteLuid}));
  }
}